import React, { useMemo } from 'react';
import { EntityDetailDialog } from './EntityDetailDialog';
import { useEntityMapTab } from '../../hooks/useEntityMapTab';
import { isSet } from '../../utils/entityTypeDetection';

export interface LocalityDetailDialogProps {
    open: boolean;
    entity: any | null;
    entityType: string;
    onClose: () => void;
    onEdit?: (entity: any) => void;
    onOpenNewUi?: (entity: any) => void;
    onDelete?: (entity: any) => Promise<void> | void;
    onClone?: (entity: any) => void;
}

export const LocalityDetailDialog: React.FC<LocalityDetailDialogProps> = ({
    open,
    entity,
    entityType,
    onClose,
    onEdit,
    onOpenNewUi,
    onDelete,
    onClone
}) => {
    const isSetEntity = isSet(entityType);
    const filterScope = entity?.FilterScope || entity?.filterScope;
    const filterScopeString = typeof filterScope === 'string'
        ? filterScope
        : (filterScope?.Id || filterScope?.id || filterScope?.DisplayName || filterScope?.displayName || '');
    const hasFilterScope = !!filterScopeString;
    const additionalTabsStartIndex = hasFilterScope && isSetEntity ? 3 : 2;

    const { additionalTabs, handleTabChange } = useEntityMapTab({
        entity,
        entityType,
        config: {
            mode: 'locality',
            tabLabel: 'Map',
            supportsMapping: (type) => ['school', 'building', 'responsibilitycenter'].includes(type.toLowerCase()),
            hasLocationData: (e) => !!e && (
                !!(e.Address || e.City || e.State || e.Zip) ||
                !!(e.Latitude && e.Longitude)
            )
        },
        additionalTabsStartIndex
    });

    if (!entity) {
        return null;
    }

    return (
        <EntityDetailDialog
            open={open}
            entity={entity}
            entityType={entityType}
            onClose={onClose}
            onEdit={onEdit}
            onOpenNewUi={onOpenNewUi}
            onDelete={onDelete}
            onClone={onClone}
            additionalTabs={additionalTabs}
            onTabChange={handleTabChange}
        />
    );
};
